import React from 'react';
import { Customer } from '../../model/customer';
import { entityManagerProvider } from '../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { SalesTransaction } from '../../model/sales-transaction';
import { TransactionType } from '../../model/transaction-type';
import { DateInput } from '@progress/kendo-react-dateinputs';

interface SalesTranactionList {
  salesTranstions: SalesTransaction[];
  selected: SalesTransaction;
  customers: Customer[];
  ids: number;
  loading: boolean;
  types: TransactionType[];
}

class SalesTransactions extends React.Component<any, SalesTranactionList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      salesTranstions: [] as SalesTransaction[],
      selected: null as SalesTransaction,
      customers: [] as Customer[],
      ids: 0 as number,
      loading: true,
      types: [] as TransactionType[],
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addSalesTransaction = this.addSalesTransaction.bind(this);
    this.remove = this.remove.bind(this);
    this.cancleSelection = this.cancleSelection.bind(this);
    this.handleCustomerFilterChange = this.handleCustomerFilterChange.bind(
      this
    );
  }

  cancleSelection() {
    this.rejectChanges();
  }
  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('SalesTransactions').expand(
      'customer, transactionType'
    );
    const queryTypes = new EntityQuery('TransactionTypes');
    const queryCustomers = new EntityQuery('Customers');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        salesTranstions: qr.results,
        loading: false,
      });
      this.manager.executeQuery(queryCustomers).then((qr) => {
        this.setState({
          customers: qr.results,
        });
      });
      this.manager.executeQuery(queryTypes).then((qr) => {
        this.setState({
          types: qr.results,
        });
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }
  handleCustomerFilterChange(event) {
    this.setState({
      loading: true,
    });
    if (event.target.value !== '0') {
      const query = new EntityQuery('SalesTransactions')
        .where('customerId', 'equals', event.target.value)
        .expand('customer, transactionType');
      this.manager.executeQuery(query).then((qr) => {
        this.setState({
          selected: null,
          salesTranstions: qr.results,
          loading: false,
        });
      });
    } else {
      const query = new EntityQuery('SalesTransactions').expand(
        'customer, transactionType'
      );
      this.manager.executeQuery(query).then((qr) => {
        this.setState({
          selected: null,
          salesTranstions: qr.results,
          loading: false,
        });
      });
    }
  }
  addSalesTransaction() {
    this.setState({
      ids: this.state.ids - 1,
    });
    let salesTransaction = this.manager.createEntity(
      SalesTransaction.prototype.entityType,
      {
        applicationUserId: this.props.authorizedUser.Id,
        createdOn: new Date(),
        modifiedOn: new Date(),
        salesTransactionId: this.state.ids,
      }
    ) as SalesTransaction;
    // salesTransaction.applicationUserId = this.props.authorizedUser.Id;
    // salesTransaction.createdOn = new Date();
    // salesTransaction.modifiedOn = new Date();
    // salesTransaction.salesTransactionId = this.state.ids;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: salesTransaction,
      salesTranstions: this.state.salesTranstions.concat([salesTransaction]),
    });
  }

  remove(ent: SalesTransaction) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }

  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }

  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then((res) => {
        // refresh customer list to remove deleted customers
        let sales = this.manager.getEntities(
          'SalesTransaction'
        ) as SalesTransaction[];
        sales = sales.sort(
          (a, b) => a.salesTransactionId - b.salesTransactionId
        );
        this.setState({
          selected: null,
          salesTranstions: sales,
          loading: false,
        });
      })
      .catch(function(error) {
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        const query = new EntityQuery('SalesTransactions');
        this.manager.executeQuery(query).then((res) => {
          this.setState({
            selected: null,
            salesTranstions: res.results,
            loading: false,
          });
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    let sales = this.manager.getEntities(
      'SalesTransaction'
    ) as SalesTransaction[];
    sales = sales.sort((a, b) => a.salesTransactionId - b.salesTransactionId);
    this.setState({
      selected: null,
      salesTranstions: sales,
    });
  }

  renderPaymentEdit() {
    let salesTransaction = this.state.selected;

    function handleTypeChange(event) {
      salesTransaction.transactionTypeId = event.target.value;
    }
    function handleCustomerChange(event) {
      salesTransaction.customerId = event.target.value;
    }
    function changeValueDate(event) {
      salesTransaction.valueDate = event.value;
    }
    if (salesTransaction) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() &&
                  this.state.selected.transactionTypeId > 0
                }
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, salesTransaction)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <Card.Title>Sales Transaction Details</Card.Title>

              <form>
                <div className="form-group row">
                  <div className="col-lg-6">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="description"
                      value={salesTransaction.description || ''}
                      onChange={salesTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Amount</label>
                    <input
                      className="form-control"
                      type="number"
                      name="amount"
                      step="0.10"
                      value={salesTransaction.amount || ''}
                      onChange={salesTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>exChange Rate</label>
                    <input
                      className="form-control"
                      type="number"
                      name="exchangeRate"
                      step="0.10"
                      value={salesTransaction.exchangeRate || ''}
                      onChange={salesTransaction.handleChange}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Value</label>
                    <div className="from-control">
                      <DateInput
                        className="from-control"
                        name="valueDate"
                        format="dd/MM/yyyy"
                        value={salesTransaction.valueDate}
                        onChange={changeValueDate}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <label>Transaction Type</label>
                    <select
                      className="form-control"
                      name="transactionTypeId"
                      onChange={handleTypeChange}
                      value={salesTransaction.transactionTypeId || 0}
                    >
                      <option key={0}>Select Type</option>
                      {this.state.types?.map((type) => {
                        return (
                          <option
                            key={type.transactionTypeId}
                            value={type.transactionTypeId}
                          >
                            {type.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label>Customer</label>
                    <select
                      className="form-control"
                      name="customerId"
                      onChange={handleCustomerChange}
                      value={salesTransaction.customerId || 0}
                    >
                      <option key={0}>Select Customer</option>
                      {this.state.customers?.map((customer) => {
                        return (
                          <option
                            key={customer.customerId}
                            value={customer.customerId}
                          >
                            {customer.customerName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.renderPaymentEdit()}
        <Card border="primary" style={{ width: '100%' }}>
          <Card.Header>
            <div className="row">
              <div className="col-md-6">
                <button
                  className="btn btn-primary ml-2"
                  type="button"
                  onClick={this.addSalesTransaction}
                >
                  <i className="fa fa-plus"></i>
                  Add Sales Transaction
                </button>
                <button
                  className="btn btn-warning ml-2"
                  type="button"
                  onClick={this.cancleSelection}
                >
                  <i className="fa fa-undo"></i>
                  Cancel
                </button>
              </div>
              <div className="col-lg-4">
                <select
                  className="form-control"
                  name="customerId"
                  onChange={this.handleCustomerFilterChange}
                >
                  <option key={0} value={0}>
                    Select Customer
                  </option>
                  {this.state.customers?.map((customer) => {
                    return (
                      <option
                        key={customer.customerId}
                        value={customer.customerId}
                      >
                        {customer.customerName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Card.Title>
              Note:"Debit to increase Customer Dues, Credit decrease customer
              dues"
            </Card.Title>
            <div className="card card-custom card-stretch">
              {this.state.loading ? (
                <div className="row" style={{ minHeight: '200px' }}>
                  <Loader
                    size="large"
                    style={{ position: 'relative', margin: '60px auto' }}
                    type="converging-spinner"
                  />
                </div>
              ) : (
                <Table className="table" responsive="sm" bordered>
                  <thead>
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <h5>Total</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5> Balance :</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc - val.amount;
                          }, 0)}
                        </h5>
                      </td>
                    </tr>
                    <tr>
                      <th>#</th>
                      <th>Description</th>
                      <th>Customer</th>
                      <th>Credit</th>
                      <th>Debit</th>
                      <th>Rate</th>
                      <th>Value</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.salesTranstions &&
                      this.state.salesTranstions.map((salesTrans, idx) => {
                        return (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor:
                                salesTrans === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() =>
                              this.setState({ selected: salesTrans })
                            }
                          >
                            <td>{salesTrans.salesTransactionId}</td>
                            <td>{salesTrans.description}</td>
                            <td>{salesTrans.customer?.customerName}</td>
                            <td>
                              {salesTrans.transactionType?.transactionTypeId ===
                              1
                                ? salesTrans.amount
                                : ''}
                            </td>
                            <td>
                              {salesTrans.transactionType?.transactionTypeId ===
                              2
                                ? salesTrans.amount
                                : ''}
                            </td>
                            <td>{salesTrans.exchangeRate}</td>
                            <td>{this.dateFormatter(salesTrans.valueDate)}</td>
                            <td>{this.dateFormatter(salesTrans.createdOn)}</td>
                          </tr>
                        );
                      })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        <h5>Total</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 2
                              ? acc + val.amount
                              : acc + 0;
                          }, 0)}
                        </h5>
                      </td>
                      <td>
                        <h5> Balance :</h5>
                      </td>
                      <td>
                        <h5>
                          {this.state.salesTranstions.reduce((acc, val) => {
                            return val.transactionTypeId === 1
                              ? acc + val.amount
                              : acc - val.amount;
                          }, 0)}
                        </h5>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default SalesTransactions;
